import { Badge, Button, Tooltip } from 'antd';
import React from 'react';
import styles from './ButtonTooltipBadge.module.scss';
import { ButtonTooltipBadgeProps } from './ButtonTooltipBadge.type';

const ButtonTooltipBadge: React.FC<ButtonTooltipBadgeProps> = ({
  title,
  content,
  badge,
  onClick,
  tooltipPlacement = 'left',
  dataTestId = 'button-tooltip-badge'
}) => {
  return (
    <div id="area" className={styles['Container']} data-testid={dataTestId}>
      <Badge size="small" count={badge}>
        <Tooltip
          placement={tooltipPlacement}
          title={title}
          getPopupContainer={() =>
            document.getElementById('area') as HTMLElement
          }
        >
          <Button onClick={onClick} className={styles['Button']}>
            {content}
          </Button>
        </Tooltip>
      </Badge>
    </div>
  );
};

export default ButtonTooltipBadge;
